module.exports = __webpack_public_path__ + "static/media/grph-stat2-100.579d1307.svg";